type SortType =
  | "name"
  | "startDate"
  | "endDate"
  | "completionDate"
  | "creationDate"
  | "rank"
  | "author";

type Sort =
  | `ascending${Capitalize<SortType>}`
  | `descending${Capitalize<SortType>}`
  | `customCriteria:${string}:asc`
  | `customCriteria:${string}:desc`;

export type { Sort };
